import {Tooltip, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {IService} from './ServiceList';
import ServicePatternIcon from '@icons/ServicePatternIcon';

interface IProps {
	service: IService;
	patternIcon?: boolean;
	color?: string | null;
}

export default function Service(props: IProps) {
	const {service, patternIcon = true, color = null} = props;
	const {t} = useTranslation();
	// @ts-ignore
	const name = t(`services_list.${service.name}`);
	if (service.isLocal) {
		return (
			<Link to={service.link} className="flex flex-col space-y-1 items-center text-center">
				{
					patternIcon ? (
							<ServicePatternIcon>
								{service.icon}
							</ServicePatternIcon>
						) :
						(
							service.icon
						)
				}
				<Typography className="min-h-8" sx={{
					color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.100',
					fontSize: (theme) => theme.typography.fontSize - 2
				}}>{name}</Typography>
			</Link>
		);
	} else if (service.link) {
		return (
			<a href={service.link} className="flex flex-col space-y-1 items-center text-center">
				{
					patternIcon ? (
							<ServicePatternIcon>
								{service.icon}
							</ServicePatternIcon>
						) :
						(
							service.icon
						)
				}
				<Typography className="min-h-8" sx={{
					color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.100',
					fontSize: (theme) => theme.typography.fontSize - 2
				}}>{name}</Typography>
			</a>
		);
	} else {
		return (
			<Tooltip title={t('soon')} placement="top" enterTouchDelay={0}>
				<div className="flex flex-col space-y-1 items-center text-center disabled-service">
					<div style={{opacity: 0.4}}>
						{
							patternIcon ? (
									<ServicePatternIcon>
										{service.icon}
									</ServicePatternIcon>
								) :
								(
									service.icon
								)
						}
					</div>
					<Typography className="h-8" sx={{
						color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.100',
						opacity: 0.7,
						fontSize: (theme) => theme.typography.fontSize - 2
					}}>{name}</Typography>
				</div>
			</Tooltip>
		);
	}
}
